/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Magazine_Cover_TextInputs */

const en_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazine Cover Text`)
};

const es_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto de la Portada de la Revista`)
};

const fr_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte de la Couverture du Magazine`)
};

const de_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazin-Covertext`)
};

const ja_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マガジンの表紙テキスト`)
};

const zh_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`杂志封面文字`)
};

const ar_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نص غلاف المجلة`)
};

const id_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teks Sampul Majalah`)
};

const it_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo di Copertina Rivista`)
};

const ru_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст Обложки Журнала`)
};

const pt_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto da Capa da Revista`)
};

const ko_magazine_cover_text = /** @type {(inputs: Magazine_Cover_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잡지 표지 텍스트`)
};

/**
* | output |
* | --- |
* | "Magazine Cover Text" |
*
* @param {Magazine_Cover_TextInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const magazine_cover_text = /** @type {((inputs?: Magazine_Cover_TextInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Magazine_Cover_TextInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_magazine_cover_text(inputs)
	if (locale === "es") return es_magazine_cover_text(inputs)
	if (locale === "fr") return fr_magazine_cover_text(inputs)
	if (locale === "de") return de_magazine_cover_text(inputs)
	if (locale === "ja") return ja_magazine_cover_text(inputs)
	if (locale === "zh") return zh_magazine_cover_text(inputs)
	if (locale === "ar") return ar_magazine_cover_text(inputs)
	if (locale === "id") return id_magazine_cover_text(inputs)
	if (locale === "it") return it_magazine_cover_text(inputs)
	if (locale === "ru") return ru_magazine_cover_text(inputs)
	if (locale === "pt") return pt_magazine_cover_text(inputs)
	return ko_magazine_cover_text(inputs)
});